import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import RequestApproval from './RequestApproval';

import utils from './../../lib/utils';

export default class SoftwareApproval extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
    };

    this.onDeclineClick = this.onDeclineClick.bind(this);
    this.onApproveClick = this.onApproveClick.bind(this);
    this.onDataChange = this.onDataChange.bind(this);
  }

  componentDidMount() {
    const requestId = utils.getURLParameterByName('ID');

    this.props.getBookingSoftwareRequest({ requestId });
  }

  onDataChange(data) {
    const newData = Object.assign({}, this.state.data, data);

    this.setState({
      data: newData,
    });
  }

  onDeclineClick(event) {
    event.stopPropagation();
    event.preventDefault();

    // Validations
    if (!this.state.data.notes) {
      this.setState({
        dataValidationErrors: {
          notes: 'Please enter reason to decline',
        },
      });
    } else {
      this.setState({
        dataValidationErrors: {},
      }, () => {
        // Get request ID from URL
        const requestId = utils.getURLParameterByName('ID');
        const userId = utils.getURLParameterByName('userId');

        // Send decline request
        this.props.postBookingSoftwareRequestDecline({
          userId,
          requestId,
          ...this.state.data,
        });
      });
    }
  }

  onApproveClick(event) {
    event.stopPropagation();
    event.preventDefault();

    // Get request ID from URL
    const requestId = utils.getURLParameterByName('ID');
    const userId = utils.getURLParameterByName('userId');

    this.props.postBookingSoftwareRequestApproved({
      userId,
      requestId,
      ...this.state.data,
    });
  }

  render() {
    let message = '';
    let isError = true;

    if (this.props.softwareRequest.status === 'APPROVED') {
      message = (
        <p className="message--big">
          Request has already been approved.
        </p>
        );
      isError = false;
    } else if (this.props.softwareRequest.status === 'DECLINED') {
      message = (
        <p className="message--big">
          Request has already been declined.
        </p>
        );
      isError = false;
    } else if (this.props.softwares.isApproved === true) {
      message = (
        <p className="message--big">
          Request has been approved.
        </p>
        );
      isError = false;
    } else if (this.props.softwares.isApproved === false) {
      message = 'Sorry! Unable to approve software registration request';
      isError = true;
    } else if (this.props.softwares.isDeclined === true) {
      message = (
        <p className="message--big">
          Request has been declined.
        </p>
        );
      isError = false;
    } else if (this.props.softwares.isDeclined === false) {
      message = 'Sorry! Unable to decline software registration request';
      isError = true;
    }

    return (
      <div className="auth-reset-password">
        <div className="auth-reset-password__container" >
          <h4>Approve Software Registration</h4>
          <div
            className={
              classnames(
                'message', {
                  'message--success': !isError,
                  'message--error': isError,
                },
              )
            }
          >
            {message}
          </div>
          {
            typeof this.props.softwares.isApproved !== 'boolean'
            && this.props.softwareRequest.status === 'PENDING'
            && typeof this.props.softwares.isDeclined !== 'boolean' ?
              <RequestApproval
                {...this.props}
                onCancel={this.onDeclineClick}
                onApprove={this.onApproveClick}
                onChange={this.onDataChange}
                data={this.state.data}
                errors={this.state.dataValidationErrors}
              /> :
              undefined
          }
        </div>
      </div>
    );
  }
}

SoftwareApproval.defaultProps = {
  getBookingSoftwareRequest: () => {},
  postBookingSoftwareRequestApproved: () => {},
  postBookingSoftwareRequestDecline: () => {},
};

SoftwareApproval.propTypes = {
  getBookingSoftwareRequest: PropTypes.func,
  postBookingSoftwareRequestApproved: PropTypes.func,
  postBookingSoftwareRequestDecline: PropTypes.func,
  softwares: PropTypes.shape({
    isApproved: PropTypes.bool,
    isDeclined: PropTypes.bool,
  }).isRequired,
  softwareRequest: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
};
